import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import TextField from "@material-ui/core/TextField";
// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import ModalCargando from "../../../components/Generales/ModalCargando.js";
import ModalEditarAlumno from "../Alumnos/ModalEditarAlumno.jsx";
import ModalProgramarCita from "../Asesorias/ModalProgramarCita.jsx"
import Globales from "utils/Globales";
import { Edit, GroupAdd, InsertDriveFileRounded, Close, AddCircle, Search, Check, Update } from "@material-ui/icons";
import CardBody from "components/Card/CardBody.jsx";
import InputAdornment from '@material-ui/core/InputAdornment';
import ModalMotivosCancelacion from "../Asesorias/ModalMotivosCancelacion.jsx";
import ModalMovimientos from "./ModalMovimientos.jsx";

const ClassAsesoria = {
    Estado: "Agendada",
    Fecha: new Date(),
    Modalidad: "",
    MotivoCita: "",
    MotivosCancelacion: "",
    NombreAlumno: "",
    NombreAula: "",
    NombreIdioma: "",
    NombreMaestro: "",
    _id: { _increment: '0', _machine: '0', _pid: '0', _timestamp: '0' },
    _idAlumno: null,
    _idAula: { _increment: '0', _machine: '0', _pid: '0', _timestamp: '0' },
    _idIdioma: null,
    _idMaestro: null,
}
class ToeflAlumnos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: '',
            EstadoAlumno: "Activo",
            ClaseAlumno: "Vacio",
            FiltrarNombres: "",
            ListaAlumnos: [],
            AlumnoSeleccionado: {},
            Disabled: false,
            mensaje: "",
            br: false,
            show: false,
            cargando: false,
            CheckAll: false,
            colorNotificacion: 'success',
            colorTableRow: "white",
            errorIDIdioma: false,
            entroFiltrar: false,
            notificacion: false,
            CuerpoCargando: "Cargando",
            Total: 0,
            TotalSeleccionado: 0,
        };
        //Variable global para indicar el total de registros que se obtendra de la base de datos
        global.entrar = true;
        //this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
    }

    //Función para pasar datos de los alumnos desde el modal hacia la vista
    RegresarMensaje = (mensaje) => {
        this.setState({ mensaje: mensaje, colorNotificacion: "success" });
        this.showNotification();
        this.ListaAlumnosBusquedaFiltradaNombreYEstado(this.state.FiltrarNombres, this.state.EstadoAlumno, this.state.ClaseAlumno);
    }
    async ListaAlumnosBusquedaFiltradaNombreYEstado(Texto, Estado, Clase) {
        this.setState({ cargandoAlumnos: true });
        await fetch(Globales.Url + 'Toefl/Toefl/ListaAlumnosBusquedaFiltradaNombreYEstado', {
            method: 'POST',
            headers: {
                Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
            }
            , body: JSON.stringify({ Texto: Texto, Estado: Estado, Clase: Clase == "Vacio" ? null : Clase })
        }
        ).then(res => res.json())
            .then(data => {
                //console.log(data);
                if (data.error) { //Error en la respuesta
                    this.setState({ ListaAlumnos: [], mensaje: data.mensaje, colorNotificacion: "danger", Activo: 1, cargandoAlumnos: false });
                    this.showNotification();
                } else { //Filtrado exitoso
                    let ListaAux = [].concat(data.ListaAlumnos || []);
                    this.setState({ ListaAlumnos: ListaAux, Activo: 1, cargandoAlumnos: false });
                }
            })
            .catch(err => this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true }));
    }
    async IniciarProceso(idALumno) {
        this.setState({ cargandoAlumnos: true });
        await fetch(Globales.Url + 'Toefl/Toefl/IniciarProcesoToefl', {
            method: 'POST',
            headers: {
                Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
            }
            , body: JSON.stringify({ idAlumno: this.state.AlumnoSeleccionado._id })
        }
        ).then(res => res.json())
            .then(data => {
                //console.log(data);
                if (data.error) { //Error en la respuesta
                    this.setState({ ListaAlumnos: [], mensaje: data.mensaje, colorNotificacion: "danger", Activo: 1, cargandoAlumnos: false });
                    this.showNotification();
                } else { //Filtrado exitoso
                    this.RegresarMensaje(data.mensaje);
                    this.showNotification();
                }
                this.ListaAlumnosBusquedaFiltradaNombreYEstado(this.state.FiltrarNombres, this.state.EstadoAlumno, this.state.ClaseAlumno);
            })
            .catch(err => this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true }));
    }
    async CancelarProceso(idALumno) {
        this.setState({ cargandoAlumnos: true });
        await fetch(Globales.Url + 'Toefl/Toefl/CancelarProccesoToefl', {
            method: 'POST',
            headers: {
                Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
            }
            , body: JSON.stringify({
                idAlumno: this.state._id,
                motivos: this.state.Motivos
            })
        }
        ).then(res => res.json())
            .then(data => {
                //console.log(data);
                if (data.error) { //Error en la respuesta
                    this.setState({ ListaAlumnos: [], mensaje: data.mensaje, colorNotificacion: "danger", Activo: 1, cargandoAlumnos: false });
                    this.showNotification();
                } else { //Filtrado exitoso
                    this.RegresarMensaje(data.mensaje);
                    this.showNotification();
                }
                this.ListaAlumnosBusquedaFiltradaNombreYEstado(this.state.FiltrarNombres, this.state.EstadoAlumno, this.state.ClaseAlumno);
            })
            .catch(err => this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true }));
    }
    async CertificadoTOEFL() {
        this.setState({ cargando: true });

        await fetch(Globales.Url + 'Toefl/Toefl/GenererarConstanciaToefl', {
            method: 'POST', headers: {
                Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
            }
            , body: JSON.stringify({ idAlumno: this.state.AlumnoSeleccionado._id })
        }).then(res => res.json())
            .then(data => {
                //console.log(data);
                if (data.error) { //Error en la respuesta
                    this.setState({ mensaje: data.mensaje, colorNotificacion: "danger", cargando: false });
                    this.showNotification();
                    this.setState({ cargando: false });
                } else { //Filtrado exitoso56
                    // *Abir PDF en otra pestaña
                    this.openPdf(data.data)

                    this.setState({ cargando: false });
                }
            })
            .catch(err => this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true }));
    }

    //Funciones para abrir modales
    openModalInscribirNuevoAlumno = () => {
        let externo = this.state.EstadoAlumno == "Aplicacion_TOEFL"
        this.setState({ showModalEditarAlumno: true, Externo: externo, op: 3 });
    }
    openModalDardeBajaAlumno = (id) => {
        this.setState({ _id: id, showMotivos: true, });
    }
    openModalEditarAlumno = (alumno) => {
        this.setState({ AlumnoSeleccionado: alumno, showModalEditarAlumno: true, Titulo: "...", op: 1 });
    }
    PreguntaIniciarProceso = (alumno) => {
        this.setState({ AlumnoSeleccionado: alumno, NombreAlumno: alumno.NombreCompleto, show: true });
    }
    PreguntaObtenerCertificado = (alumno) => {
        this.setState({ AlumnoSeleccionado: alumno, NombreAlumno: alumno.NombreCompleto, showCertificado: true });
    }

    openshowModalMovimientos = (alumno) => {
        this.setState({ idAlumno: alumno._id, showMovimientos: true })
    }
    //Funciónes que recuperan valores para los modales
    eventoModalEditarAlumno = (mensaje) => {
        //Cambiar valores por default
        this.setState({ showModalEditarAlumno: false, op: 0 })
        if (mensaje != 'esc') {
            this.setState({ mensaje: mensaje, colorNotificacion: "success" })
            this.showNotification();
        }
    }
    eventoIniciarProceso = (valor) => {
        this.setState({ show: false })
        if (valor) {
            this.IniciarProceso();
        }
    }
    eventoObtenerCertificado = (valor) => {
        this.setState({ showCertificado: false })
        if (valor) {
            this.CertificadoTOEFL();
        }
    }
    eventoModalMovimientos = (valor) => {
        this.setState({ showMovimientos: false })
    }


    //Función que habilita la notificación
    showNotification() {
        var x = [];
        this.setState({ br: true });
        this.setState(x);
        this.alertTimeout = setTimeout(
            function () {
                this.setState({ br: false, notificacion: false });
                this.setState(x);
            }.bind(this),
            4000
        );
    }

    openPdf(basePdf) {
        let byteCharacters = atob(basePdf);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: 'application/pdf;base64' });
        let fileURL = URL.createObjectURL(file);
        window.open(fileURL);
    }
    //Función para obtener el texto de los inputs
    handleChange(e) {
        const { name, value } = e.target;
        //console.log(e.target);

        if (name == "FiltrarNombres") {
            if (value.length > 0) {
                this.setState({ [name]: value });
                this.ListaAlumnosBusquedaFiltradaNombreYEstado(value, this.state.EstadoAlumno, this.state.ClaseAlumno)
            }
            else {
                this.setState({ [name]: value, ListaAlumnos: [] });
            }
        }
        if (name == "EstadoAlumno") {
            this.setState({ [name]: value });
            this.ListaAlumnosBusquedaFiltradaNombreYEstado(this.state.FiltrarNombres, value, this.state.ClaseAlumno);
        }

        if (name == "ClaseAlumno") {
            this.setState({ [name]: value });
            this.ListaAlumnosBusquedaFiltradaNombreYEstado(this.state.FiltrarNombres, this.state.EstadoAlumno, value);
        }

        this.setState({ [name]: value });
    }
    openProgramarExamen() {
        this.setState({
            op: "TOEFL",
            showProgramar: true,
        })
    }
    openMovimientos(idAlumno) {
        this.setState({ idAlumno, showMovimientos: true, })
    }

    eventoClickProgramarExamen = (mensaje) => {
        this.setState({
            showProgramar: false,
            mensaje: mensaje,
            colorNotificacion: "success",
        });
        if (mensaje != "esc") {
            this.showNotification();
        }
    }

    eventoModalmotivos = (mensaje) => {
        this.setState({ showMotivos: false, });
        if (mensaje != 'esc') {
            this.setState({ Motivos: mensaje }, () => {
                this.CancelarProceso();
            })
        }
    }
    CallbackMotivos = (Motivos) => { }

    eventoMovimientos = (mensaje) => {
        this.setState({ showMovimientos: false, });
    }


    render() {
        const { classes } = this.props;

        let agregar;
        if (this.state.showModalEditarAlumno == true) {
            agregar =
                <ModalEditarAlumno
                    Titulo={this.state.Titulo}
                    showModalEditarAlumno={this.state.showModalEditarAlumno}
                    eventClick={this.eventoModalEditarAlumno}
                    op={this.state.op}
                    AlumnoSeleccionado={this.state.AlumnoSeleccionado}
                    Externo={this.state.Externo}
                    parentCallback={this.RegresarMensaje}
                />
        }
        if (this.state.showProgramar == true) {
            agregar =
                <ModalProgramarCita
                    Titulo={"Programar examen TOEFL"}
                    cita={ClassAsesoria}
                    show={this.state.showProgramar}
                    eventClick={this.eventoClickProgramarExamen}
                    op={"TOEFL"}
                />
        }
        if (this.state.showMotivos == true) {
            agregar =
                <ModalMotivosCancelacion
                    show={this.state.showMotivos}
                    eventClick={this.eventoModalmotivos}
                    parentCallback={this.CallbackMotivos}
                />
        }
        if (this.state.showMovimientos == true) {
            agregar =
                <ModalMovimientos
                    show={this.state.showMovimientos}
                    idAlumno={this.state.idAlumno}
                    eventClick={this.eventoModalMovimientos}
                />
        }


        if (this.state.cargando == true) {
            agregar = (
                <ModalCargando
                    Cuerpo={this.state.CuerpoCargando}
                    show={this.state.cargando}
                />
            );
        }

        let alumnos;
        if (this.state.ListaAlumnos.length > 0) {
            alumnos =
                this.state.ListaAlumnos.map(alumno => {
                    let enCurso = !["No_iniciado", "Concluido", "Cancelado"].includes(alumno.EstadoToefl);
                    let esFinalizado = ["Evaluado", "Concluido",].includes(alumno.EstadoToefl);

                    return (
                        <tr style={{ cursor: "default" }} hover>
                            <td onClick={() => this.openModalEditarAlumno(alumno)} style={{ verticalAlign: "middle" }}>{alumno.NumeroCuenta}</td>
                            <td onClick={() => this.openModalEditarAlumno(alumno)} style={{ verticalAlign: "middle" }}>{alumno.NombreCompleto}</td>
                            <td onClick={() => this.openModalEditarAlumno(alumno)} style={{ verticalAlign: "middle" }}>{alumno.Clase}</td>
                            <td onClick={() => this.openModalEditarAlumno(alumno)} style={{ verticalAlign: "middle" }}>{alumno.EstadoToefl.replace(/_/g, " ")}</td>
                            <td style={{ display: "flex", verticalAlign: "middle", float: "right", gap: "5px" }}>
                                {esFinalizado && <Button title="Obtener certificado" color="info" round justIcon size="sm" onClick={() => this.PreguntaObtenerCertificado(alumno)}><InsertDriveFileRounded /></Button>}
                                {!enCurso && <Button title="Iniciar proceso" color="info" round justIcon size="sm" onClick={() => this.PreguntaIniciarProceso(alumno)}><Check /></Button>}
                                <Button title="Ver movimientos" color="info" round justIcon size="sm" onClick={() => this.openshowModalMovimientos(alumno)}><Update /></Button>
                                <Button title="Editar alumno" color="info" round justIcon size="sm" onClick={() => this.openModalEditarAlumno(alumno)}><Edit /></Button>
                                {enCurso && <Button title="Dar de baja al alumno" color="danger" round justIcon size="sm" onClick={() => this.openModalDardeBajaAlumno(alumno._id)}><Close /></Button>}
                            </td>
                        </tr>
                    )
                })
        }
        else {
            alumnos =
                <tr>
                    <td style={{ textAlign: "center", marginTop: "10px" }} colSpan={5}>NO HAY ALUMNOS</td>
                </tr>
        }


        //console.log(this.state.ListaAlumnos)
        return (
            <div>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={10}>
                        <Card>
                            <CardHeader color="info" text>
                                <h4 className={classes.cardTitle}>Buscar Alumnos</h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem style={{ marginBottom: "10px" }} xs={12} sm={12} md={3}>
                                        <FormControl fullWidth size="small" variant="outlined">
                                            <InputLabel id="estadolabel">Estado alumno</InputLabel>
                                            <Select
                                                labelId="estadolabel"
                                                value={this.state.EstadoAlumno}
                                                onChange={this.handleChange.bind(this)}
                                                name="EstadoAlumno"
                                                label="Estado alumno"
                                            >
                                                <MenuItem disabled>Seleccione un estado</MenuItem>
                                                <MenuItem value={"Activo"}>Activo</MenuItem>
                                                <MenuItem value={"Inactivo"}>Inactivo</MenuItem>
                                                <MenuItem value={"Aplicacion_TOEFL"}>Aplicación  TOEFL</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={3}>
                                        <FormControl fullWidth size="small" variant="outlined">
                                            <InputLabel id="Claselabel">Clase</InputLabel>
                                            <Select
                                                labelId="Claselabel"
                                                fullWidth={true}
                                                value={this.state.ClaseAlumno}
                                                onChange={this.handleChange.bind(this)}
                                                name="ClaseAlumno"
                                                label="Clase"
                                            >
                                                <MenuItem value={"Vacio"}>Todos</MenuItem>
                                                <MenuItem value={"Niño"}>Niño</MenuItem>
                                                <MenuItem value={"Adolescente"}>Adolescente</MenuItem>
                                                <MenuItem value={"Adulto"}>Adulto</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem style={{ marginBottom: "10px", marginLeft: "10px" }} xs={12} sm={12} md={6} />
                                    <GridItem xs={12} sm={12} md={6}>
                                        <TextField
                                            fullWidth
                                            id="FiltrarNombres"
                                            variant="outlined"
                                            type="text"
                                            size="small"
                                            label="Matricula o nombre"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search />
                                                    </InputAdornment>
                                                ),
                                                onChange: this.handleChange.bind(this),
                                                value: this.state.FiltrarNombres,
                                                name: "FiltrarNombres",
                                                id: "FiltrarNombres",
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <Button size="sm" type="submit" color="info" round className="pull-right" onClick={() => this.openModalInscribirNuevoAlumno()}><AddCircle />&nbsp;Nuevo alumno</Button>
                                        <Button size="sm" type="submit" color="info" round className="pull-right" onClick={() => this.openProgramarExamen()}><AddCircle />&nbsp;Programar examen</Button>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardHeader color="info" text>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <h4 className="pull-left">Alumnos</h4>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <h4 className="pull-right" style={{ marginRight: "15px", marginTop: 0 }}>{this.state.ListaAlumnos.length} Alumno(s)</h4>
                                    </GridItem>
                                </GridContainer>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <div className="table-responsive-xl table-wrapper-scroll-y">
                                            <table className="table table-sm table-hover">
                                                <thead>
                                                    <th>No. Cuenta</th>
                                                    <th>Nombre completo</th>
                                                    <th>Clase</th>
                                                    <th>Estado</th>
                                                    <th></th>
                                                </thead>
                                                <tbody>
                                                    {this.state.cargandoAlumnos &&
                                                        <tr>
                                                            <td style={{ textAlign: "center", marginTop: "10px" }} colSpan={5}>Cargando...</td>
                                                        </tr>}
                                                    {alumnos}
                                                </tbody>
                                            </table>
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <div id="">
                    <ModalPregunta
                        Titulo={"TOEFL"}
                        Cuerpo={`¿Estas seguro de empezar proceso de TOEFL para el elumno: ${this.state.NombreAlumno || ""}?`}
                        show={this.state.show}
                        headerColor="info"
                        eventClick={this.eventoIniciarProceso}
                    />
                    <ModalPregunta
                        Titulo={"Obntener certificado"}
                        Cuerpo={`¿Estas seguro Obtener el certificado TOEFL de: ${this.state.NombreAlumno || ""}?\n**¡esto dara por concluido el proceso.**`}
                        show={this.state.showCertificado}
                        headerColor="info"
                        eventClick={this.eventoObtenerCertificado}
                    />
                    {agregar}
                </div>
                <div id="">
                    <Snackbar
                        place="tr"
                        color={this.state.colorNotificacion}
                        message={this.state.mensaje}
                        open={this.state.br}
                        closeNotification={() => this.setState({ br: false })}
                        close
                    />
                </div>

            </div>
        )
    }
}

export default withStyles(headerLinksStyle)(ToeflAlumnos);